<div class="button-div">
    <p-toolbar styleClass="pb-0 pr-2" class="flex justify-content-end">
        <div class="mr-2">
            <button id="{{ idPrefix + '_cancel' }}" type="button" pButton label="{{ hrKey.common.buttonCancel | translate }}" class="p-button-text" (click)="onCancel()"></button>
        </div>
        <div *ngIf="showSave">
            <button id="{{ idPrefix + '_save' }}" type="submit" pButton label="{{ hrKey.common.buttonSave | translate }}" (click)="onSave()"></button>
        </div>
        <div *ngIf="showDelete">
            <button id="{{ idPrefix + '_delete' }}" type="submit" pButton label="{{ hrKey.common.buttonDelete | translate }}" (click)="onRemove()"></button>
        </div>
    </p-toolbar>
</div>
